import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { Clock } from 'lucide-react';
import { TimeOption } from '../../utils/helpers';

const styles: StylesConfig<TimeOption, false> = {
  control: (base, state) => ({
    ...base,
    minHeight: '36px',
    height: '36px',
    borderColor: state.isFocused ? '#4A90E2' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 1px #4A90E2' : 'none',
    borderRadius: '0.5rem',
    '&:hover': { borderColor: '#4A90E2' },
  }),
  valueContainer: (base) => ({ ...base, height: '36px', padding: '0 8px 0 36px' }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (base) => ({ ...base, height: '36px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '4px' }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#4A90E2' : state.isFocused ? '#e5e7eb' : 'white',
    color: state.isSelected ? 'white' : '#212121',
    cursor: 'pointer',
  }),
  menu: (base) => ({ ...base, zIndex: 50 }),
};

interface TimeSelectProps {
  value: string;
  options: TimeOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  showIcon?: boolean;
}

export const TimeSelect: React.FC<TimeSelectProps> = ({
  value,
  options,
  onChange,
  placeholder = 'Select',
  disabled = false,
  showIcon = false,
}) => {
  const selected = options.find((o) => o.value === value) || null;

  const customStyles: StylesConfig<TimeOption, false> = {
    ...styles,
    valueContainer: (base) => ({
      ...base,
      height: '36px',
      padding: showIcon ? '0 8px 0 36px' : '0 8px',
    }),
  };

  return (
    <div className="relative flex-1">
      {showIcon && (
        <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-base-content/50 pointer-events-none z-10" />
      )}
      <Select<TimeOption>
        value={selected}
        onChange={(opt) => onChange(opt?.value || '')}
        options={options}
        styles={customStyles}
        placeholder={placeholder}
        isDisabled={disabled}
        isClearable={false}
      />
    </div>
  );
};
